import type { AppError } from "@/shared/api";

/**
 * i18n-ключі помилок login. Літерали → типобезпечний `t()` (звірка проти
 * MessageSchema). Login-специфічний override `invalidCredentials` лишається в
 * `auth.*`; решта — спільний namespace `errors.*` (ADR-0010 D7).
 */
export type LoginErrorKey =
  | "auth.errors.invalidCredentials"
  | "errors.validation"
  | "errors.forbidden"
  | "errors.conflict"
  | "errors.rateLimited"
  | "errors.network"
  | "errors.server"
  | "errors.unknown";

/**
 * Тонкий адаптер `AppError → login-i18n-ключ` (ADR-0010 D9). Гілка по `kind`
 * (interceptor гарантує `AppError`), плюс login-override:
 * - `auth` → «Невірний email або пароль» (anti-enumeration, не «Сесію завершено»);
 * - `notFound` → generic `errors.server` (404 company у login = помилка входу, D7).
 */
export function mapLoginError(e: AppError): LoginErrorKey {
  switch (e.kind) {
    case "auth":
      return "auth.errors.invalidCredentials";
    case "validation":
      return "errors.validation";
    case "forbidden":
      return "errors.forbidden";
    case "conflict":
      return "errors.conflict";
    case "rateLimited":
      return "errors.rateLimited";
    case "network":
      return "errors.network";
    case "server":
    case "notFound":
      return "errors.server";
    default:
      return "errors.unknown";
  }
}
